import { SeoConfig } from '@spartacus/storefront';

export const defaultSeoConfig: SeoConfig = {
  seo: {
    structuredData: {
      disableInDevMode: false,
    },
  },
};
